import { Heading, VStack } from '@chakra-ui/react'
import React from 'react'

interface Props {
  title: string
  children: React.ReactNode
}

// A titled group of notification settings. Used twice on the settings page:
// "as it happens" for the event-driven emails, "at a fixed time" for the
// digest (E5, EM-D26).
export default function NotificationsGroup({ title, children }: Props) {
  return (
    <VStack spacing={5} align="stretch">
      <Heading as="h2" size="md">
        {title}
      </Heading>
      {children}
    </VStack>
  )
}
